<template>
    <div>
        <v-card>
            <v-card-title>
                Opened revisions
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="2">
                        <b>Title</b>
                    </v-col>
                    <v-col cols="1">
                        <b>Time limit</b>
                    </v-col>
                    <v-col cols="1">
                        <b>Task count</b>
                    </v-col>
                    <v-col cols="1">
                        <b>Chapter count</b>
                    </v-col>
                </v-row>
                <v-row v-for="(revision, index) in openedRevisionList" :key="index">
                    <v-col cols="2">
                        {{ revision.rev_title }}
                    </v-col>
                    <v-col cols="1">
                        {{ revision.time_limit }} s
                    </v-col>
                    <v-col cols="1">
                        {{ revision.task_number }}
                    </v-col>
                    <v-col cols="1">
                        {{ revision.chapter_list }}
                    </v-col>
                    <v-col cols="1">
                        <v-icon @click="startRevision(revision.id)">start</v-icon>
                    </v-col>

                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>

import axios from '../axios-auth'

export default {
    data() {
        return {
            openedRevisionList: [],
        }
    },
    props:{ }
    ,    
    components: {
        
    },
    mounted() {
         this.initData()
    },
    methods : {
        initData() {
            const _data = {
                course_id: this.$route.params.course_id
            }

            axios.post('/get-student-revisions', _data, this.$store.getters.getAxiosConfig)
                .then(res => {
                    this.openedRevisionList = res.data.opened

            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })            
        },
        startRevision(_rev_id) {
            this.$router.push({name:'revision_student', params: {course_id: this.$route.params.course_id, rev_id:_rev_id}})
        }
    }
}
</script>